<template>
    <div class="source">
        <!-- banner图 -->
        <div class="source-banner">
            <!-- <Header></Header> -->
            <div class="source-intro">
                <div class="intro-title">
                    时空智能 无限可能
                </div>
                <p class="intro-content">
                    激活行业数据价值，打造全场景融合产品生态圈
                </p>
            </div>
        </div>
        <!-- 资源列表 -->
        <div class="source-content">
            <!-- 外层1200框 -->
            <div class="source-list">
                <!-- 左侧资源菜单 -->
                <div class="source-menu">
                    <!-- 单个菜单项 -->
                    <div
                        class="menu-item"
                        v-for="(item,index) in sourceTypeList"
                        :key="index"
                    >
                        <!-- 标题 -->
                        <div class="item-title">
                            <!-- 标题名称 -->
                            <div class="title-name">
                                <img
                                    :src="getTitleImg(item.name)"
                                    alt=""
                                >
                                <span>{{ item.name }}</span>
                            </div>
                            <!-- 下拉选择 -->
                            <div class="icon-box">
                                <img
                                    @click="fadeDropDownMenuHandle(index,item)"
                                    class="title-icon"
                                    :src="collapseList.indexOf(index) == -1 ?tilteDropImg.arrowDown : tilteDropImg.arrowUp"
                                    alt=""
                                >
                            </div>
                        </div>
                        <!-- 资源分类 -->
                        <el-collapse-transition>
                            <ul
                                :class="{'source-type':true}"
                                v-if="item.subChildren && item.subChildren.length > 0 && collapseList.indexOf(index) != -1"
                            >
                                <li
                                    v-for="(subItem,subIndex) in item.subChildren"
                                    :key="subIndex"
                                >
                                    <span
                                        @click="selectedSourceTypeHandle(item.name,subItem)"
                                        :class="{active:activeOption.menuName == item.name && activeOption.subMenuName == subItem.name}"
                                    >
                                        {{ subItem.name }}
                                    </span>
                                </li>
                            </ul>
                        </el-collapse-transition>
                    </div>
                </div>
                <!-- 右侧资源列表 -->
                <div class="source-group">
                    <!-- 顶部搜索、过滤 -->
                    <div class="source-filter">
                        <!-- 左侧过滤 -->
                        <div class="condition-list">
                            <span>
                                排序方式：
                            </span>
                            <ul>
                                <li
                                    :class="{conditionActive: termActive == item}"
                                    v-for="(item,index) in conditionList"
                                    :key="index"
                                    @click="querySourceDetailHandle(item)"
                                >
                                    {{ item }}
                                </li>
                            </ul>
                        </div>
                        <!-- 右侧搜索 -->
                        <div class="search-input">
                            <input
                                type="text"
                                class="query-source"
                                placeholder="搜索关键字"
                                v-model="sourceListFormInline.title"
                            >
                            <div
                                class="search-icon"
                                @click="querySourceListByTitleHanle"
                            >
                                <img
                                    src="@/assets/source/icon_search.png"
                                    alt=""
                                >
                            </div>
                        </div>
                    </div>
                    <!-- 资源列表 -->
                    <div class="pagination-source">
                        <div v-if="specialSourceList.length > 0">
                            <div :class="{'special-source':true,'paratope': specialSourceList.length % 3 == 2}">
                                <div
                                    :class="{'source-item':true,'source-top': [0,1,2].indexOf(index) != -1}"
                                    v-for="(item,index) in specialSourceList"
                                    :key="index"
                                    @click="showSourceItemDetailHandle(item.id)"
                                >
                                    <img
                                        :src="item.cover"
                                        alt=""
                                    >
                                    <div class="article-name">
                                        {{ item.title }}
                                    </div>
                                    <p class="article-summary">
                                        {{ item.summary }}
                                    </p>
                                    <div class="article-info article-common">
                                        <span>
                                            <!-- {{ item.articleType }} -->
                                            service Map
                                        </span>
                                        <span>
                                            <img
                                                src="@/assets/source/icon_watch.png"
                                                alt=""
                                            >
                                            <!-- <span class="scan-num">{{ item.articleScan }}</span> -->
                                            <span class="scan-num">{{item.views}}</span>
                                        </span>
                                    </div>
                                    <div class="overall-merit">
                                        <span class="overall-label">综合评价：</span>
                                        <div class="overall-list">
                                            <img
                                                v-for="(imgItem,imgIndex) in (new Array(3))"
                                                :key="imgIndex"
                                                src="@/assets/source/icon_pingfen.png"
                                                alt=""
                                            >
                                        </div>
                                    </div>
                                    <div class="artcle-author article-common">
                                        <span class="author-info">
                                            <img
                                                src="@/assets/source/icon_touxiang.png"
                                                alt=""
                                            >
                                            <span>{{ item.author }}</span>
                                        </span>
                                        <span class="upload-time">{{ formatTime(item.publishTime,"yyyy-MM-dd") }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            class="nodataList"
                            v-else
                        >暂无数据</div>

                        <div class="pagination-component">
                            <el-pagination
                                background
                                layout="prev, pager, next"
                                @current-change="handleCurrentChange"
                                :current-page="sourceListFormInline.current"
                                :page-size="9"
                                :total="totalCount"
                            >
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 底部 -->
        <!-- <Footer></Footer> -->
    </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import {
    getSpecialSourceColumnHandle,
    getSpecialTypeDirectoryHandle,
    getTypeSourceArticleHandle,
} from "@/api/source/source";
import { formatTime } from "@/utils/formatTime";

export default {
    name: "Source",
    data() {
        return {
            collapseList: [],
            tilteDropImg: {
                arrowUp: require("@/assets/source/icon_shangla.png"),
                arrowDown: require("@/assets/source/icon_xiala.png"),
            },
            sourceTypeList: [],
            // sourceTypeList: [
            //     {
            //         titleImg: require("@/assets/source/icon_water.png"),
            //         titleName: "水环境",
            //         typeList: [
            //             "业务核查电子导航",
            //             "地理要素在线编辑",
            //             "草原合理载畜量遥感计算",
            //             "非法采矿区监测",
            //             "草原长势监测",
            //             "草原产草量遥感计算",
            //             "然保护区人类活动核查",
            //         ],
            //     },
            //     {
            //         titleImg: require("@/assets/source/icon_dqhl.png"),
            //         titleName: "大气环境",
            //         typeList: [
            //             "PM2.5监测",
            //             "NH3（氨氮）监测",
            //             "臭氧监测",
            //             "PM10监测",
            //             "高层建筑阴影提取",
            //         ],
            //     },
            //     {
            //         titleImg: require("@/assets/source/icon_sthj.png"),
            //         titleName: "大气环境",
            //         typeList: [
            //             "秦岭城市群",
            //             "地理要素在线编辑",
            //             "草原合理载畜量遥感计算",
            //             "非法采矿区监测",
            //             "character varying",
            //         ],
            //     },
            // ],
            activeOption: {
                menuName: "",
                subMenuName: "",
            },
            // conditionList: ["最高访问量", "最高评分", "最高修改"],
            conditionList: ["最高访问量", "修改时间", "发布时间"],
            termActive: "最高访问量",
            totalCount: 0,
            sourceListFormInline: {
                title: "",
                current: 1,
                size: 9,
                topicId: "",
                sort: "",
            },
            specialSourceList: [],
            // specialSourceList: [
            //     {
            //         articleImg: require("@/assets/source/zyfw_img1.png"),
            //         articleName: " 2020年中国乡镇人口数量",
            //         articleSummary:
            //             "在水利行业，业务部门需要对土壤、气象、环境进行实时动态监测,在水利行业，业务部门需要对土壤、气象、环境进行实时动态监测...",
            //         articleType: "Map Service",
            //         articleScan: 2253,
            //         articleMerit: 3,
            //         articleAuthor: "管理员",
            //         uploadTime: "2021-3-25",
            //     },
            //     {
            //         articleImg: require("@/assets/source/zyfw_img1.png"),
            //         articleName: " 2020年中国乡镇人口数量",
            //         articleSummary:
            //             "在水利行业，业务部门需要对土壤、气象、环境进行实时动态监测...",
            //         articleType: "Map Service",
            //         articleScan: 2253,
            //         articleMerit: 3,
            //         articleAuthor: "管理员",
            //         uploadTime: "2021-3-25",
            //     },
            //     {
            //         articleImg: require("@/assets/source/zyfw_img1.png"),
            //         articleName: " 2020年中国乡镇人口数量",
            //         articleSummary:
            //             "在水利行业，业务部门需要对土壤、气象、环境进行实时动态监测...",
            //         articleType: "Map Service",
            //         articleScan: 2253,
            //         articleMerit: 3,
            //         articleAuthor: "管理员",
            //         uploadTime: "2021-3-25",
            //     },
            //     {
            //         articleImg: require("@/assets/source/zyfw_img1.png"),
            //         articleName: " 2020年中国乡镇人口数量",
            //         articleSummary:
            //             "在水利行业，业务部门需要对土壤、气象、环境进行实时动态监测...",
            //         articleType: "Map Service",
            //         articleScan: 2253,
            //         articleMerit: 3,
            //         articleAuthor: "管理员",
            //         uploadTime: "2021-3-25",
            //     },
            //     {
            //         articleImg: require("@/assets/source/zyfw_img1.png"),
            //         articleName: " 2020年中国乡镇人口数量",
            //         articleSummary:
            //             "在水利行业，业务部门需要对土壤、气象、环境进行实时动态监测...",
            //         articleType: "Map Service",
            //         articleScan: 2253,
            //         articleMerit: 3,
            //         articleAuthor: "管理员",
            //         uploadTime: "2021-3-25",
            //     },
            //     {
            //         articleImg: require("@/assets/source/zyfw_img1.png"),
            //         articleName: " 2020年中国乡镇人口数量",
            //         articleSummary:
            //             "在水利行业，业务部门需要对土壤、气象、环境进行实时动态监测...",
            //         articleType: "Map Service",
            //         articleScan: 2253,
            //         articleMerit: 3,
            //         articleAuthor: "管理员",
            //         uploadTime: "2021-3-25",
            //     },
            //     {
            //         articleImg: require("@/assets/source/zyfw_img1.png"),
            //         articleName: " 2020年中国乡镇人口数量",
            //         articleSummary:
            //             "在水利行业，业务部门需要对土壤、气象、环境进行实时动态监测...",
            //         articleType: "Map Service",
            //         articleScan: 2253,
            //         articleMerit: 3,
            //         articleAuthor: "管理员",
            //         uploadTime: "2021-3-25",
            //     },
            //     {
            //         articleImg: require("@/assets/source/zyfw_img1.png"),
            //         articleName: " 2020年中国乡镇人口数量",
            //         articleSummary:
            //             "在水利行业，业务部门需要对土壤、气象、环境进行实时动态监测...",
            //         articleType: "Map Service",
            //         articleScan: 2253,
            //         articleMerit: 3,
            //         articleAuthor: "管理员",
            //         uploadTime: "2021-3-25",
            //     },
            //     {
            //         articleImg: require("@/assets/source/zyfw_img1.png"),
            //         articleName: " 2020年中国乡镇人口数量",
            //         articleSummary:
            //             "在水利行业，业务部门需要对土壤、气象、环境进行实时动态监测...",
            //         articleType: "Map Service",
            //         articleScan: 2253,
            //         articleMerit: 3,
            //         articleAuthor: "管理员",
            //         uploadTime: "2021-3-25",
            //     },
            //     {
            //         articleImg: require("@/assets/source/zyfw_img1.png"),
            //         articleName: " 2020年中国乡镇人口数量",
            //         articleSummary:
            //             "在水利行业，业务部门需要对土壤、气象、环境进行实时动态监测...",
            //         articleType: "Map Service",
            //         articleScan: 2253,
            //         articleMerit: 3,
            //         articleAuthor: "管理员",
            //         uploadTime: "2021-3-25",
            //     },
            // ],
        };
    },
    components: {
        Header,
        Footer,
    },
    computed: {},
    methods: {
        formatTime,
        selectedSourceTypeHandle(menu, subMenu) {
            this.activeOption.menuName = menu;
            this.activeOption.subMenuName = subMenu.name;
            this.sourceListFormInline.topicId = subMenu.id;
            console.log(this.activeOption);
            this.queryTypeSourceArticleHandle();
        },
        querySourceDetailHandle(type) {
            let typeList = {
                最高访问量: "views",
                修改时间: "updateTime",
                发布时间: "publishTime",
            };
            this.termActive = type;
            this.sourceListFormInline.sort = typeList[type];
            this.queryTypeSourceArticleHandle();
        },
        fadeDropDownMenuHandle(num, data) {
            // collapseList 数组中存储的是关闭的下拉菜单
            if (this.collapseList.indexOf(num) == -1) {
                this.collapseList.push(num);
            } else {
                // collapseList 数组中删除关闭的菜单下标
                let index = this.collapseList.findIndex((value, index, arr) => {
                    return value == num;
                });
                this.collapseList.splice(index, 1);
            }

            // 请求菜单资源数据
            this.querySpecialTypeDirectoryHandle(data);
        },
        // 栏目查询
        querySpecialSourceColumnHandle() {
            getSpecialSourceColumnHandle()
                .then((res) => {
                    // let requestList = [];
                    // const columnList = res.data.data;
                    // for (let i = 0; i < columnList.length; i++) {
                    //     requestList.push(
                    //         this.querySpecialTypeDirectoryHandle(
                    //             columnList[i]["id"],
                    //             columnList
                    //         )
                    //     );
                    // }
                    // axios
                    //     .all(requestList)
                    //     .then((res) => {
                    //         console.log("菜单项查询成功!");
                    //         this.sourceTypeList = columnList;
                    //         console.log(this.sourceTypeList);
                    //     })
                    //     .catch((err) => {
                    //         console.log(err);
                    //     });
                    // 获取所有的栏目
                    const columnList = res.data.data;
                    columnList.map((item) => {
                        this.sourceTypeList.push(item);
                    });
                    console.log(this.sourceTypeList);
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        // 根据栏目查询专题
        querySpecialTypeDirectoryHandle(menu) {
            getSpecialTypeDirectoryHandle({ menuId: menu.id })
                .then((res) => {
                    const subMenu = res.data.data;
                    let subMenuLsit = [];
                    this.sourceTypeList.map((item) => {
                        if (item.id == menu.id) {
                            item["subChildren"] = subMenu;
                        }
                        subMenuLsit.push(item);
                    });
                    this.sourceTypeList = Object.assign([], subMenuLsit);
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        getTitleImg(type) {
            let imgUrl;
            switch (type) {
                case "水环境":
                    imgUrl = require("@/assets/source/icon_water.png");
                    break;
                case "大气环境":
                    imgUrl = require("@/assets/source/icon_dqhl.png");
                    break;
                case "生态环境":
                    imgUrl = require("@/assets/source/icon_sthj.png");
                    break;
            }
            return imgUrl;
        },
        // 获取文章列表
        queryTypeSourceArticleHandle() {
            console.log(this.sourceListFormInline);
            getTypeSourceArticleHandle(this.sourceListFormInline)
                .then((res) => {
                    this.specialSourceList = res.data.data.records;
                    this.totalCount = res.data.data.total;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        querySourceListByTitleHanle() {
            this.queryTypeSourceArticleHandle();
        },
        handleCurrentChange(val) {
            this.sourceListFormInline.current = val;
            this.queryTypeSourceArticleHandle();
        },
        showSourceItemDetailHandle(id) {
            this.$router.push({
                name: "Detail",
                query: {
                    id,
                },
            });
        },
    },
    mounted() {
        this.querySpecialSourceColumnHandle(); //获取左侧菜单栏目
        this.queryTypeSourceArticleHandle(); //查找文章列表
    },
};
</script>
<style scoped>
p,
ul,
li {
    padding: 0;
    margin: 0;
    list-style: none;
}
.source-banner {
    box-sizing: border-box;
    border: 1px solid transparent;
    width: 100%;
    height: 500px;
    background: url("../../assets/source/zyfw_banner.png");
    position: relative;
}
.source-intro {
    width: 395px;
    margin: auto;
    margin-top: 181px;
    text-align: center;
}
.intro-title {
    font-size: 40px;
    font-family: "PingFangSC-Semibold, sans-serif";
    font-weight: bold;
    color: #f6f6f6;
    line-height: 32px;
}
.intro-content {
    font-size: 18px;
    margin-top: 25px;
    font-family: "PingFangSC-Regular,sans-serif";
    font-weight: 400;
    color: #f6f6f6;
}
.source-content {
    box-sizing: border-box;
    padding-top: 60px;
    background: #f5f5f5;
}
.source-list {
    margin-top: 30px;
    padding-bottom: 30px;
    width: 1200px;
    margin: auto;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}
.source-menu {
    width: 258px;
}
.item-title {
    box-sizing: border-box;
    padding-left: 12px;
    padding-right: 14px;
    height: 38px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #2a868f;
}
.title-name img {
    width: 21px;
    height: 21px;
    vertical-align: middle;
}
.title-name span {
    font-size: 14px;
    font-family: "PingFang-SC-Medium,sans-serif";
    font-weight: 500;
    color: #ffffff;
    margin-left: 4px;
    vertical-align: middle;
    cursor: pointer;
}
.item-title {
    cursor: pointer;
}
.icon-box {
    display: flex;
    justify-content: center;
    align-items: center;
}
.source-type {
    padding: 12px 0;
    background: #fff;
}
.source-type li {
    box-sizing: border-box;
    padding: 12px 0;
    padding-left: 23px;
}
.source-type li span {
    padding-left: 14px;
    font-size: 14px;
    font-family: "PingFang-SC-Medium,sans-serif";
    font-weight: 500;
    color: #666666;
    position: relative;
    cursor: pointer;
}
.source-type li .active {
    color: #27b3b1;
}
.source-type li .active::after {
    content: "";
    position: absolute;
    left: 0;
    top: 2.5px;
    width: 3px;
    height: 14px;
    background: #27b3b1;
    border-radius: 2px;
    z-index: 2;
}
.source-group {
    width: 902px;
    margin-left: 40px;
}
.source-filter {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.condition-list {
    display: flex;
    justify-content: flex-start;
}
.condition-list span {
    font-size: 14px;
    line-height: 14px;
    font-family: "PingFangSC-Medium, sans-serif";
    padding: 11px 0;
    font-weight: 500;
    color: #666666;
}
.condition-list ul::after {
    content: "";
    display: block;
    clear: left;
}
.condition-list ul li {
    box-sizing: border-box;
    float: left;
    margin: 0 10px;
    padding: 11px 0;
    font-size: 14px;
    line-height: 14px;
    font-family: "PingFangSC-Medium, sans-serif";
    font-weight: 500;
    color: #666666;
    border-bottom: 2px solid transparent;
    cursor: pointer;
}
.condition-list ul li.conditionActive {
    color: #27b3b1;
    border-bottom: 2px solid #27b3b1;
}
.search-input {
    position: relative;
}
.query-source {
    box-sizing: border-box;
    width: 269px;
    height: 36px;
    border: 1px solid #d0d0d0;
    border-radius: 5px;
    outline: none;
    padding-left: 12px;
    padding-right: 37px;
}
.search-icon {
    width: 20px;
    height: 20px;
    box-sizing: border-box;
    position: absolute;
    top: 8px;
    right: 10px;
    z-index: 5;
    border: 1px dashed #888888;
    cursor: pointer;
}
.search-icon img {
    width: 18px;
    height: 18px;
    display: block;
}
.query-source::placeholder {
    font-size: 14px;
    font-family: "PingFangSC-Regular,sans-serif";
    font-weight: 400;
    color: #999999;
}
.query-source:focus,
.query-source:focus-visible {
    border: 1px solid #27b3b1;
}
.paratope::after {
    content: "";
    width: 285px;
}
.special-source {
    box-sizing: border-box;
    padding-left: 7px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}
.nodataList {
    margin-top: 50px;
    margin-bottom: 30px;
    margin-left: 125px;
    font-size: 16px;
    font-family: "PingFangSC-Regular,sans-serif";
    font-weight: 400;
    color: #999999;
}
.source-item {
    width: 285px;
    box-sizing: border-box;
    margin-top: 40px;
    padding: 10px;
    padding-bottom: 14px;
    background: #fff;
    border-radius: 2px;
    cursor: pointer;
}
.source-top {
    margin-top: 20px;
}
.special-source img {
    width: 265px;
    height: 170px;
}
.article-name {
    font-size: 16px;
    font-family: "PingFangSC-Semibold, sans-serif";
    font-weight: bold;
    color: #333333;
    margin-top: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.article-common {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.article-summary {
    margin-top: 12px;
    font-size: 14px;
    font-family: "PingFangSC-Regular,sans-serif";
    font-weight: 400;
    color: #666666;
    line-height: 20px;
    height: 40px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
.article-info {
    margin-top: 20px;
    font-family: "PingFangSC-Regular,sans-serif";
    font-weight: 400;
    color: #666666;
}
.article-info:nth-of-type(1) {
    font-size: 14px;
    font-family: "PingFang-SC-Medium,sans-serif";
    font-weight: 500;
    color: #333333;
}
.article-info span img {
    width: 24px;
    height: 24px;
    vertical-align: middle;
}
.article-info span .scan-num {
    font-size: 14px;
    font-family: "PingFangSC-Light,sans-serif";
    font-weight: 300;
    color: #666666;
    margin-left: 3px;
    vertical-align: middle;
}
.overall-merit {
    margin-top: 10px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
}
.overall-label {
    font-size: 14px;
    font-family: "PingFangSC-Regular,sans-serif";
    font-weight: 400;
    color: #666666;
}
.overall-list {
    display: flex;
    justify-content: flex-start;
}
.overall-list img {
    width: 20px;
    height: 20px;
    display: block;
    margin-left: 4px;
}
.artcle-author {
    margin-top: 20px;
}
.author-info img {
    width: 24px;
    height: 24px;
    vertical-align: middle;
}
.author-info span {
    font-size: 13px;
    font-family: "PingFangSC-Regular,sans-serif";
    font-weight: 400;
    color: #666666;
    vertical-align: middle;
}
.upload-time {
    font-size: 12px;
    font-family: "PingFangSC-Light,sans-serif";
    font-weight: 300;
    color: #999999;
}
.pagination-component {
    margin-top: 70px;
    margin-bottom: 75px;
}

@import url("../../assets/font/font.css");
</style>
<style>
.source .el-pagination {
    margin-left: 110px;
}
/* 分页插件 */
.source .el-pagination.is-background .btn-next,
.source .el-pagination.is-background .btn-prev,
.source .el-pagination.is-background .el-pager li {
    box-sizing: border-box;
    background: #fff;
    border: 1px solid #e2e2e2;
    border-radius: 50% !important;
}

/* .source .el-pagination.is-background .el-pager li:not(.disabled):hover {
    color: #27b3b1;
} */

.source .el-pagination.is-background .el-pager li:not(.disabled).active {
    background: #27b3b1;
}
</style>